import { render, staticRenderFns } from "./InstitutionDetails.vue?vue&type=template&id=78555422&"
import script from "./InstitutionDetails.vue?vue&type=script&lang=js&"
export * from "./InstitutionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports